<template>
  <div class="navbar">
    <div class="pull_btn">
      <el-tooltip class="item" effect="dark" content="同步广点通推广计划、广告组、广告、广告创意历史数据到mkt" placement="top">
        <el-button
          size="mini"
          icon="el-icon-question"
          :loading="gdt_loading"
          plain
          @click="updateGdtSource()"
        >
          同步广点通历史数据
        </el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="同步今日头条广告组、广告计划、广告创意历史数据到mkt" placement="top">
        <el-button
          size="mini"
          icon="el-icon-question"
          :loading="jrtt_loading"
          plain
          @click="updateJrttSource()"
        >
          同步头条历史数据
        </el-button>
      </el-tooltip>

    </div>
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img :src="avatar+'/128'" class="user-avatar"> -->
          <div>
            <i class="el-icon-user-solid" />
            {{ this.$store.state.user.name }}
          </div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <p
            style="line-height: 30px;
    padding: 0 17px;
    font-size: 14px;"
          >用户名 ：{{ this.$store.state.user.name }}</p>
          <router-link to="/">
            <el-dropdown-item>{{ $t('navbar.dashboard') }}</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/bread-crumb';
import Hamburger from '@/components/hamburger-item';
import AdvertiserResource from '@/api/advertiser';
const advertiserResource = new AdvertiserResource();

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  data() {
    return {
      gdt_loading: false,
      jrtt_loading: false,
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar', 'device', 'userId']),
  },
  methods: {

    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },

    // 同步广点通广告主历史数据
    async updateGdtSource() {
      this.gdt_loading = true;
      await advertiserResource
        .updateGdtSource()
        .then((response) => {
          this.$message({
            message: response.message,
            type: 'success',
          });
        })
        .catch(() => {
          this.$message({
            message: '同步失败',
            type: 'error',
          });
        }).then(() => {
          this.gdt_loading = false;
        });
    },

    // 同步头条历史数据
    async updateJrttSource() {
      this.jrtt_loading = true;
      await advertiserResource
        .updateJrttSource()
        .then((response) => {
          this.$message({
            message: response.message,
            type: 'success',
          });
        })
        .catch(() => {
          this.$message({
            message: '同步失败',
            type: 'error',
          });
        }).then(() => {
          this.jrtt_loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 4px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  .pull_btn{
    position: absolute;
    top: 12px;
    right: 150px;
    .is-plain{
      margin-left: 30px;
    }
  }
  .crear_front_cache {
    position: absolute;
    top: 16px;
    right: 300px;
  }
}
</style>
